import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const SETTINGS_PANE_CONTENT_CLASS_NAME = 'SettingsPaneContent';
export const SETTINGS_PANE_CONTENT_CLASS_SLOTS = ['root'] as const;

export type SettingsPaneContentClassSlot =
	(typeof SETTINGS_PANE_CONTENT_CLASS_SLOTS)[number];

export interface SettingsPaneContentClasses {
	root: string;
}

export type SettingsPaneContentClassKey = keyof SettingsPaneContentClasses;

export const getSettingsPaneContentUtilityClass = (slot: string) =>
	generateUtilityClass(SETTINGS_PANE_CONTENT_CLASS_NAME, slot);

export const settingsPaneContentClasses = generateUtilityClasses<
	keyof SettingsPaneContentClasses
>(SETTINGS_PANE_CONTENT_CLASS_NAME, ['root']);
export default settingsPaneContentClasses;
